import { memo } from 'react';

export const SkeletonSelection = memo(() => (
    <div className="vss-skeleton-selection">
        <div className="vss-skeleton-selection__device"/>

        <div className="vss-skeleton-selection__device"/>
    </div>
));
